import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  min-width: 1060px;
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  .title {
    display: flex;
    padding: 24px 20px;
    justify-content: center;
    align-items: center;
  }

  .btn_container {
    display: flex;
    padding: 8px 20px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
  }
`;

export const Content = styled.div`
  display: flex;
  min-width: 738px;
  padding: 0px 20px;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  align-items: stretch;
`;
